import * as React from "react";
import { Navigate } from "react-router";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { ShieldCheck, CirclePlay, ListChecks, Plus, Sparkles } from "lucide-react";
import { ApprovalsPage } from "@/pages/approvals";
import { ApprovalDetailPage } from "@/pages/approval-detail";
import { RunsPage } from "@/pages/runs";
import { RunDetailPage, StartRunPage } from "@/pages/run-detail";
import { AgentTaskDetailPage } from "@/pages/agent-tasks";
import { WorkItemsPage } from "@/pages/work-items";
import { ZotPage } from "@/pages/zot";
import { HelpPage } from "@/pages/help";

export const coreWorkRoutes: FeatureRouteModule = {
  shellRoutes: [
    { index: true, element: React.createElement(Navigate, { to: "/zot", replace: true }) },
    { path: "overview", element: React.createElement(Navigate, { to: "/zot", replace: true }) },
    {
      path: "inbox",
      element: React.createElement(Navigate, { to: "/approvals", replace: true }),
    },
    {
      path: "approvals",
      handle: { title: "Approvals" },
      element: React.createElement(ApprovalsPage),
    },
    {
      path: "approvals/:approvalId",
      handle: { title: "Approval decision" },
      element: React.createElement(ApprovalDetailPage),
    },
    { path: "runs", handle: { title: "Runs" }, element: React.createElement(RunsPage) },
    { path: "runs/new", handle: { title: "New run" }, element: React.createElement(StartRunPage) },
    {
      path: "runs/:runId",
      handle: { title: "Run detail" },
      element: React.createElement(RunDetailPage),
    },
    {
      path: "agent-tasks",
      handle: { title: "Runs" },
      element: React.createElement(Navigate, { to: "/runs?type=agent", replace: true }),
    },
    {
      path: "agent-tasks/:taskId",
      handle: { title: "Agent task" },
      element: React.createElement(AgentTaskDetailPage),
    },
    {
      path: "work-items",
      handle: { title: "Work items" },
      element: React.createElement(WorkItemsPage),
    },
    { path: "help", handle: { title: "Help and guides" }, element: React.createElement(HelpPage) },
    { path: "zot", handle: { title: "Zot" }, element: React.createElement(ZotPage) },
  ],
  shellRouteDefs: [
    { path: "/runs/new", title: "New run", summary: "Start a run against this project." },
    {
      path: "/approvals",
      title: "Approvals",
      summary: "Decisions that gate a run, each bound to the exact action and revision.",
    },
    { path: "/work-items", title: "Work items", summary: "The work this project is tracking." },
    { path: "/help", title: "Help and guides", summary: "Zot commands and examples." },
    {
      path: "/runs",
      title: "Runs",
      summary:
        "Every run and agent task, newest first. A row never shows success before it is confirmed.",
    },
    {
      path: "/zot",
      title: "Zot",
      summary: "Project assistant. Not connected until an assistant adapter is configured.",
    },
  ],
};

export const coreWorkNav: FeatureNavModule = {
  primaryActions: [
    { to: "/zot", label: "New task", icon: Plus, end: false },
    { to: "/runs/new", label: "New run", icon: Plus, end: false },
  ],
  navGroups: [
    {
      label: "",
      items: [
        { to: "/zot", label: "Zot", icon: Sparkles, end: false },
        { to: "/approvals", label: "Approvals", icon: ShieldCheck, end: false, badge: "approvals" },
      ],
    },
    {
      label: "Work",
      items: [
        { to: "/work-items", label: "Work items", icon: ListChecks, end: false },
        { to: "/runs", label: "Runs", icon: CirclePlay, end: false },
      ],
    },
  ],
};
